import { render, staticRenderFns } from "./PartePolicial.vue?vue&type=template&id=93405a7e&"
import script from "./PartePolicial.vue?vue&type=script&lang=js&"
export * from "./PartePolicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports